import { MindARThree } from 'mind-ar/dist/mindar-image-three.prod.js';
import { getBestCameraDevice, VIDEO_CONSTRAINTS_HIGH } from './cameraQuality';

MindARThree.prototype._startVideo = async function () {
  this.video = document.createElement('video');
  this.video.setAttribute('autoplay', '');
  this.video.setAttribute('muted', '');
  this.video.setAttribute('playsinline', '');
  this.video.style.position = 'absolute';
  this.video.style.top = '0px';
  this.video.style.left = '0px';
  this.video.style.zIndex = '-2';
  this.container.appendChild(this.video);

  if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
    this.ui.showCompatibility();
    throw new Error('getUserMedia is not supported by this browser');
  }

  try {
    const deviceId = await getBestCameraDevice();

    const constraints = {
      audio: false,
      video: {
        ...VIDEO_CONSTRAINTS_HIGH, // Use 1080p constraints
        facingMode: 'environment',
      },
    };

    if (deviceId) {
        constraints.video.deviceId = { exact: deviceId };
    }

    const stream = await navigator.mediaDevices.getUserMedia(constraints);
    this.video.srcObject = stream;

    await new Promise((resolve) => {
      this.video.addEventListener('loadedmetadata', () => {
        this.video.setAttribute('width', this.video.videoWidth);
        this.video.setAttribute('height', this.video.videoHeight);
        resolve();
      });
    });

  } catch (err) {
    console.error("getUserMedia error", err);
    if (err.name === 'NotAllowedError' || err.name === 'PermissionDeniedError') {
      throw new Error('Permiso de cámara denegado. Por favor, permite el acceso en la configuración del navegador.');
    } else if (err.name === 'NotFoundError') {
        throw new Error('No se encontró ninguna cámara en este dispositivo.');
    } else if (err.name === 'NotReadableError') {
        throw new Error('La cámara está en uso por otra aplicación. Cierra otras apps que usen la cámara.');
    } else {
        throw new Error(`Error al acceder a la cámara: ${err.message}`);
    }
  }
};

export { MindARThree };
